import { gsePricingAnalyticsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const ANALYTICS_ACTION_TYPE = createNamedActions('marginCenter/analytics', {
  GET_MARGIN_ATTRIBUTION: 'GET_MARGIN_ATTRIBUTION',
  GET_LEAKAGE_BY_CAUSE: 'GET_LEAKAGE_BY_CAUSE',
  REPLAY_PRICING: 'REPLAY_PRICING',
  SET_ATTRIBUTION_LOADING: 'SET_ATTRIBUTION_LOADING',
  SET_ATTRIBUTION_ERROR: 'SET_ATTRIBUTION_ERROR',
  SET_LEAKAGE_LOADING: 'SET_LEAKAGE_LOADING',
  SET_LEAKAGE_ERROR: 'SET_LEAKAGE_ERROR',
  GET_SAMPLE_ATTRIBUTION: 'GET_SAMPLE_ATTRIBUTION',
  SET_SAMPLE_ATTRIBUTION_LOADING: 'SET_SAMPLE_ATTRIBUTION_LOADING',
  SET_SAMPLE_ATTRIBUTION_ERROR: 'SET_SAMPLE_ATTRIBUTION_ERROR',
});

export const getMarginAttributionAction = params => async dispatch => {
  dispatch({ type: ANALYTICS_ACTION_TYPE.SET_ATTRIBUTION_LOADING, payload: true });

  try {
    const { data } = await gsePricingAnalyticsApi.getMarginAttribution(params);

    return dispatch({
      type: ANALYTICS_ACTION_TYPE.GET_MARGIN_ATTRIBUTION,
      payload: data,
    });
  } catch {
    return dispatch({ type: ANALYTICS_ACTION_TYPE.SET_ATTRIBUTION_ERROR });
  }
};

export const getLeakageByCauseAction = params => async dispatch => {
  dispatch({ type: ANALYTICS_ACTION_TYPE.SET_LEAKAGE_LOADING, payload: true });

  try {
    const { data } = await gsePricingAnalyticsApi.getLeakageByCause(params);

    return dispatch({
      type: ANALYTICS_ACTION_TYPE.GET_LEAKAGE_BY_CAUSE,
      payload: data,
    });
  } catch {
    return dispatch({ type: ANALYTICS_ACTION_TYPE.SET_LEAKAGE_ERROR });
  }
};

export const replayPricingAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await gsePricingAnalyticsApi.replay(body);

  return dispatch({
    type: ANALYTICS_ACTION_TYPE.REPLAY_PRICING,
    payload: data,
  });
});

// Margin Center MC-6 (DEV-4968): the 4-leg base/LLPA/SRP/margin -> client-price split for RulesPage's
// "Sample-price attribution" strip. `params` is a ReplayPricingRequest (gsePricingPullId/product/
// noteRate/lockDays/servicingOption required; specifiedPool/servicerId/marginSnapshotId/correlationId
// optional).
export const getSampleAttributionAction = params => async dispatch => {
  dispatch({ type: ANALYTICS_ACTION_TYPE.SET_SAMPLE_ATTRIBUTION_LOADING, payload: true });

  try {
    const { data } = await gsePricingAnalyticsApi.getSampleAttribution(params);

    return dispatch({ type: ANALYTICS_ACTION_TYPE.GET_SAMPLE_ATTRIBUTION, payload: data });
  } catch {
    return dispatch({ type: ANALYTICS_ACTION_TYPE.SET_SAMPLE_ATTRIBUTION_ERROR });
  }
};

// LEN-804: same attribution slice as getMarginAttributionAction, read through the 403-inline client
// method so Today's margin card degrades to an empty state instead of reloading the page.
export const getMarginAttributionInlineAction = params => async dispatch => {
  dispatch({ type: ANALYTICS_ACTION_TYPE.SET_ATTRIBUTION_LOADING, payload: true });

  try {
    const { data } = await gsePricingAnalyticsApi.getMarginAttributionInline(params);

    return dispatch({ type: ANALYTICS_ACTION_TYPE.GET_MARGIN_ATTRIBUTION, payload: data });
  } catch {
    return dispatch({ type: ANALYTICS_ACTION_TYPE.SET_ATTRIBUTION_ERROR });
  }
};
